// extracted by mini-css-extract-plugin
export default {"summary-container":"ServiceItemMasterSummary_summary-container__0KTz9","summary-ctas":"ServiceItemMasterSummary_summary-ctas__Xyitx"};